import { AuthUser } from '../../types';
import { buildRoles } from './buildRoles';

interface CreateAuthUser {
  email: string;
  uid: string;
}

export const createAuthUser = async (user: CreateAuthUser, token: string): Promise<AuthUser> => {
  const authUser: AuthUser = {
    email: user.email,
    id: user.uid,
    roles: [],
  };

  const roles = await buildRoles(authUser, token);
  authUser.roles = roles;

  return authUser;
};
